<script>import Icon from '../Icon.svelte';
const iconNode = [["rect", { "width": "18", "height": "11", "x": "3", "y": "11", "rx": "2", "ry": "2" }], ["path", { "d": "M7 11V7a5 5 0 0 1 9.9-1" }]];
</script>

<Icon name="unlock" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
